<template>
  <div ref="elRef" class="flex" @click="clickEvent">
    <a :href="article.route" class="flex hover:text-link-primary" @click="handleClickReadingList">
      <OImage :src="getImageUrl(article.image)" class="w-[82px] h-[60px] mr-2 rounded-md" style="flex-shrink: 0" />
      <p class="text-md font-medium line-clamp-3">
        {{ article.title }}
      </p>
    </a>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OImage } from '~/modules/common/components/ui';
import { useTracking } from '~/modules/tracking/composables/useTracking';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  components: {
    OImage,
  },
  props: {
    article: {
      type: Object,
    },
  },
  setup(props) {
    const { sendKesfetEvent } = onedioEvents();
    const { sendDataLayer } = useTracking();
    const { elRef, clickEvent } = sendDataLayer(
      {
        item: props.article,
        list: 'Keşfet - Okuma Listem',
        position: 1,
        listId: 'Keşfet',
      },
      ['scroll', 'click']
    );

    const handleClickReadingList = () => {
      sendKesfetEvent('Sidebar', 'Click', 'Okuma Listem');
    };

    return { elRef, clickEvent, getImageUrl, handleClickReadingList };
  },
});
</script>
